// extracted by css-extract-rspack-plugin
export default {"IssueSidePanelContent":"IssueSidePanel-module__IssueSidePanelContent__lnAlW"};